/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Pipe, PipeTransform} from '@angular/core';

import {formatPercentage} from './format-percentage';
import {AppLocaleService} from '../locale/app-locale.service';

@Pipe({standalone: true, name: 'percentage'})
export class PercentagePipe implements PipeTransform {
  constructor(private readonly appLocale: AppLocaleService) {
  }

  transform(input: any, decimals?: number, blockNegative?: boolean): string {
    return formatPercentage(input, decimals, blockNegative, this.appLocale.getLocaleId());
  }
}
